module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "drive-card.76d52040.png" + "?" + Date.now();